"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCDevSession = void 0;
const cc_1 = require("../cc");
const types_1 = require("../cc/types");
class MbCCDevSession extends cc_1.MbCCSession {
    constructor() {
        super(...arguments);
        this.isDataValid = (data) => {
            if (data.entrypoint === types_1.EntrypointType.CCDev && data.accessToken && data.agentToken) {
                return true;
            }
            return false;
        };
        this.doRefresh = () => {
            throw new Error('method not implemented');
        };
    }
}
exports.MbCCDevSession = MbCCDevSession;
//# sourceMappingURL=index.js.map